// Radiogroup de los 5 estados de validación.
// Cada opción se renderiza con su StatusBadge; al seleccionarse se
// dibuja un borde azul corporativo alrededor.

import { html } from 'htm/preact'

import { StatusBadge } from './StatusBadge.js'

const OPTIONS = [
  'Aprobado',
  'Pendiente',
  'Requiere ajuste',
  'Bloqueado',
  'Obsoleto'
]

export function StatusSelector({ value, onChange }) {
  return html`
    <div
      class="status-selector"
      role="radiogroup"
      aria-label="Estado de validación"
    >
      ${OPTIONS.map(
        (opt) => html`
          <button
            type="button"
            role="radio"
            key=${opt}
            aria-checked=${value === opt ? 'true' : 'false'}
            class=${`status-selector__option ${value === opt ? 'status-selector__option--selected' : ''}`}
            onClick=${() => onChange(opt)}
          >
            <${StatusBadge} estado=${opt} />
          </button>
        `
      )}
    </div>
  `
}
